import { css } from '/helpers/customCSS';

export const arrowRotation = css<{ $isOpen: boolean }>`
  transition: transform 200ms ease;
  transform: ${(props) => (props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;
